import { validateExploreSearch } from "./explore-search";

export function exploreRouteValidateSearch(search: Record<string, unknown>) {
  return validateExploreSearch(search);
}

export type { ExploreSearch } from "./explore-search";
